import { CreateOrganizationRequest, RegisterResponse } from "@/types";
import api from "../api";
import { API_URL } from "../constants";
import { getTrackingMetadataPayload } from "../tracking";

export const createOrganization = async (data: CreateOrganizationRequest) => {
  let trackingMetadata;
  try {
    trackingMetadata = getTrackingMetadataPayload();
  } catch (error) {
    console.error("Failed to get tracking metadata payload");
  }
  return api.post<RegisterResponse>(`${API_URL}/v1/register`, {
    ...data,
    ...(trackingMetadata ? { trackingMetadata } : {}),
  });
};
export const getMyOrganization = async () => {
  return api.get(`${API_URL}/v1/organization/me`);
};
export const getOrganizationMembers = async () => {
  return api.get(`${API_URL}/v1/organization/members`);
};

export const deleteOrganization = async () => {
  return api.delete(`${API_URL}/v1/organization`);
};
